import { AlertFilled, InfoCircleFilled } from '@ant-design/icons';
import { Alert } from 'antd';
import { useContext } from 'react';

import { LegacyHotelContext } from 'app/context/HotelContext/LegacyHotelContext';
import { roundToDecimal } from 'app/utils/number';

import './InventoryBanner.scss';

export const InventoryBanner = () => {
  const { publishedPackages } = useContext(LegacyHotelContext);
  const filteredPackages = publishedPackages.filter(
    (pkg) => !!pkg.minimumDiscountOverride
  );

  return (
    <div className="banner-container">
      <div className="title">
        <AlertFilled /> High demand in your area
      </div>
      <Alert
        type="info"
        description={
          <>
            Exceptionally, publish your availabilities at{' '}
            <strong>a lower minimum discount on the highlighted days</strong> :
            <ul className="package-list">
              {filteredPackages.map((pkg) => {
                return (
                  pkg.minimumDiscountOverride && (
                    <li>
                      {pkg.aliasForHotel}:{' '}
                      <strong>
                        -{roundToDecimal(pkg.minimumDiscountOverride * 100)}%
                      </strong>
                    </li>
                  )
                );
              })}
            </ul>
          </>
        }
        icon={<InfoCircleFilled />}
        showIcon
        className="full-width-alert"
      />
    </div>
  );
};
